// DeleteItemModal.js
import React from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button
} from "reactstrap";
import PropTypes from "prop-types";

const DeleteItemModal = ({ isOpen, toggle, onConfirm, itemLabel, loading }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Confirm Delete</ModalHeader>
            <ModalBody>
                {loading
                    ? <div className="text-center py-4">
                        <span className="spinner-border text-danger" role="status"></span>
                    </div>
                    : <>Are you sure you want to delete this {itemLabel}?</>}
            </ModalBody>
            {!loading && (
                <ModalFooter>
                    <Button color="danger" onClick={onConfirm}>
                        Yes, Delete
                    </Button>
                    <Button color="secondary" onClick={toggle}>
                        Cancel
                    </Button>
                </ModalFooter>
            )}
        </Modal>
    );
};

DeleteItemModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    itemLabel: PropTypes.string,
    loading: PropTypes.bool
};

DeleteItemModal.defaultProps = {
    itemLabel: "item"
};

export default DeleteItemModal;